import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleComponent } from '@pages/utils/google.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';

@Component({
    selector: 'app-alert-inconsistencias',
    templateUrl: './alert-inconsistencias.component.html',
    styleUrls: ['./alert-inconsistencias.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TagManagerDirective]
})
export class AlertInconsistenciasComponent extends GoogleComponent implements OnChanges {

  @Input() alertInconsistencia: boolean = false;
  @Input() mensagemInconsistencia: string = 'A importação do arquivo foi realizada porém com algumas inconsistências, clique em reparar ou voltar para cancelar o processo.';
  @Output() alertInconsistenciaFechou = new EventEmitter();

  private readonly sectionApp = 'importacao-realizacao-pedidos';
  private readonly screenName = 'importacao-realizacao-pedidos:erro-de-produto-endereco';
  private readonly screenType = 'modal';

  constructor(public rota: Router) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alertInconsistencia?.currentValue) {
      this.pushScreenView(this.sectionApp, this.screenName, this.screenType);
    }
  }

  irParaTratativas() {
    localStorage.setItem('tratativas', 'true');
    this.rota.navigate(['/tratativas']);
  }

  fecharAlertInconsistencia() { this.alertInconsistenciaFechou.emit('Fechou'); }

  addTagManagerInteraction(elementType: string, elementContent: string) {
    return this.buildTagInteraction(elementType, elementContent, this.sectionApp, this.screenName, this.screenType);
  }
}
